import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";

const LMPDetails = ({ show, onHide, onSave, editData = null }) => {
  const [form, setForm] = useState({
    date: "",
    daysOfFlow: "",
    comment: "",
  });

  // ✅ Prefill the form in Edit Mode
  useEffect(() => {
    if (editData) {
      setForm(editData);
    } else {
      setForm({ date: "", daysOfFlow: "", comment: "" });
    }
  }, [editData, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    if (!form.date) {
      alert("Please select an LMP date");
      return;
    }

    onSave(form);
    setForm({ date: "", daysOfFlow: "", comment: "" });
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {editData ? "Edit LMP Details" : "Add LMP Details"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form>
          <div className="mb-3">
            <label className="form-label fw-semibold">LMP Date</label>
            <div className="position-relative">
              <input
                type="date"
                className="form-control pe-5"
                name="date"
                value={form.date}
                onChange={handleChange}
              />
              <i
                className="bi bi-calendar3 position-absolute"
                style={{
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#0dcaf0",
                  pointerEvents: "none",
                  fontSize: "18px",
                }}
              ></i>
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">Days of Flow</label>
            <input
              type="number"
              name="daysOfFlow"
              value={form.daysOfFlow}
              onChange={handleChange}
              placeholder="e.g. 4"
              className="form-control"
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">Comments</label>
            <input
              type="text"
              name="comment"
              value={form.comment}
              onChange={handleChange}
              placeholder="Add comments"
              className="form-control"
            />
          </div>
        </form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="danger" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" className="text-white" onClick={handleSubmit}>
          {editData ? "Update " : "Save"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LMPDetails;
